export default {
  name: 'BotDestinationModalItem',
  props: {
    index: {
      type: Number,
      require: false,
      'default': () => 0
    },
    value: String
  },
  mounted () {
    this.inpValue = this.value
  },
  data () {
    return {
      inpValue: ''
    }
  },
  computed: {
    title () {
      return '通知先' + (this.index + 1)
    }
  },
  watch: {
    inpValue: function (to) {
      this.$emit('childs-change', {
        index: this.index,
        value: to
      })
    }
  }
}